import _extends from "@babel/runtime/helpers/esm/extends";
import { useMemo } from 'react';

var cond = function cond() {
  for (var _len = arguments.length, cnds = new Array(_len), _key = 0; _key < _len; _key++) {
    cnds[_key] = arguments[_key];
  }

  return function (v) {
    return (cnds.find(function (x) {
      return x[0](v);
    }) || [null, function () {
      return undefined;
    }])[1](v);
  };
};

var codeListConfig = {
  identField: 'code',
  labelField: 'label'
};
var entityConfig = {
  identField: 'id',
  labelField: 'label'
};
/**
 * Vraci konfiguraci fieldu typu.
 *
 * @param {Object | 'codeList' | 'entity'} [fieldsConfig]
 * @param {string} [fieldsConfig.identField='code']
 * @param {string} [fieldsConfig.labelField='label']
 */

export default function useTypeFieldsConfig(fieldsConfig) {
  return useMemo(function () {
    var fc = cond([function (c) {
      return c === 'codeList';
    }, function () {
      return codeListConfig;
    }], [function (c) {
      return c === 'entity';
    }, function () {
      return entityConfig;
    }], [function () {
      return true;
    }, function (c) {
      return c;
    }])(fieldsConfig);
    return _extends({}, codeListConfig, fc);
  }, [fieldsConfig]);
}